// Cartão "estado da plataforma" (API + base de dados + versão), usado no site e no painel do backoffice.
import { useHealth } from "@ecliptica/api-client/react";
import { useTranslation } from "@ecliptica/i18n";
import { Button, Card, CardContent, CardHeader, CardTitle, StatusDot } from "@ecliptica/ui";

export function ApiStatus({ className }: { className?: string }) {
  const { t } = useTranslation("common");
  const health = useHealth();
  const apiOk = health.isPending ? null : health.isSuccess;
  const dbOk = health.isPending ? null : (health.data?.database ?? false);
  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle>{t("app.name")}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <StatusDot ok={apiOk}>
          {t("status.api")}: {apiOk === null ? t("status.checking") : t(apiOk ? "status.online" : "status.offline")}
        </StatusDot>
        <StatusDot ok={dbOk}>
          {t("status.database")}: {dbOk === null ? t("status.checking") : t(dbOk ? "status.online" : "status.offline")}
        </StatusDot>
        {health.data && <p className="text-xs text-muted-foreground">{t("status.version", { version: health.data.version })}</p>}
        {health.isError && (
          <Button size="sm" variant="outline" className="mt-2 self-start" onClick={() => void health.refetch()}>
            {t("action.retry")}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
